export default __webpack_public_path__ + "static/media/1.82a4a0e5.png";